import { IEventForm } from 'components/organisms/forms/event/EventForm';
import { IUpdateEvent } from 'services/events/types';

export const eventFormToUpdateQuery = (eventForm: IEventForm): IUpdateEvent => {
  const convertToISOString = (dateString: string): string => {
    if (dateString.includes('T')) {
      return dateString;
    }
    return new Date(dateString + 'T00:00:00.000Z').toISOString();
  };

  return {
    id: eventForm.id,
    version: eventForm.version,
    eventName: eventForm.name,
    startDate: convertToISOString(eventForm.startDate),
    endDate: convertToISOString(eventForm.endDate),
    status: eventForm.status,
    labelRequests: eventForm.labels,
  };
}; 